import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import getConfig from '../../../../util/config';
import { getThumbBySize } from '../../../../util/photo';
import { IMAGE_SIZE_CODE } from '../../../../constants/image-size-codes';
import { prependAccountSlug } from '../../../../util/account';
import FolderIcon from '../../../../components/icons/FolderIcon';
import WebGalleryThumbnailActions from '../WebGalleryThumbnailActions';
import { getAsset } from '../../../../util/assets';
import ListingCardTemplate from '../../../pro/components/ListingCardTemplate';
import { ALBUM_PRIVACY } from '../../../../constants/albums';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
};

const WebGalleryAlbumFolderCard = ({ albumFolder }) => {
  const [thumbIndex, setThumbIndex] = useState(0);
  const coverPhotoRecords = albumFolder.cover_photos?.records ?? [];
  const coverPhoto = coverPhotoRecords[thumbIndex];

  useEffect(() => {
    // Rotates image over time
    const timer = setTimeout(() => {
      setThumbIndex(
        thumbIndex + 1 >= coverPhotoRecords.length ? 0 : thumbIndex + 1,
      );
    }, 2500);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  if (!albumFolder) {
    return null;
  }

  const config = getConfig();
  const thumbs = coverPhoto?.thumbnail_urls ?? [];

  const thumbnailUrl = getThumbBySize(
    thumbs,
    IMAGE_SIZE_CODE.MEDIUM2X,
    // Important for when using local cache
    true,
  )?.url;

  const linkTo = prependAccountSlug(
    `/galleries/view/folder/${albumFolder.id}`,
    albumFolder,
  );

  return (
    <ListingCardTemplate
      icon={<FolderIcon />}
      thumbnailUrl={thumbnailUrl}
      linkTo={linkTo}
      title={albumFolder.name}
      templateLinkProps={{
        rel:
          albumFolder?.privacy === ALBUM_PRIVACY.PRIVATE
            ? 'nofollow'
            : undefined,
      }}
      className="web-gallery-album-folder-card"
      nullState={
        <>
          <div className="listing-card-template-cover-null-state">
            <img
              src={getAsset('/waldo-icon.svg')}
              alt=""
              className="album-folders-null-state-icon"
            />
            <p>No photos yet</p>
          </div>
        </>
      }
      thumbnailActions={
        <WebGalleryThumbnailActions
          albumFolderId={albumFolder.id}
          url={`${config.app.baseUrl}${linkTo}`}
          quote="Check out this awesome album!"
          entity={albumFolder}
        />
      }
    />
  );
};

WebGalleryAlbumFolderCard.propTypes = propTypes;

export default WebGalleryAlbumFolderCard;
